// @ts-nocheck
import { ProductAutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import React from "react";
import BunzlAutoCompleteProductBody, { BunzlAutoCompleteProductBodyStyles } from "./BunzlAutoCompleteProductBody";
import BunzlAutoCompleteProductFooter, { BunzlAutoCompleteProductFooterStyles } from "./BunzlAutoCompleteProductFooter";
import BunzlAutoCompleteProductWrapper, {
    BunzlAutoCompleteProductWrapperStyles,
} from "./BunzlAutoCompleteProductWrapper";

export interface BunzlAutoCompleteProductStyles {
    bunzlAutoCompleteBodyStyles?: BunzlAutoCompleteProductBodyStyles;
    bunzlAutoCompleteFooterStyles?: BunzlAutoCompleteProductFooterStyles;
    bunzlautoCompleteProductWrapperStyles?: BunzlAutoCompleteProductWrapperStyles;
}
interface BunzlAutoCompleteProductProps {
    isAuthenticated: boolean;
    autocompleteProductItem: ProductAutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: BunzlAutoCompleteProductStyles;
    variant?: "outlined" | "elevated";
    isFocused?: boolean;
}

const BunzlAutoCompleteProduct: React.FC<BunzlAutoCompleteProductProps> = ({
    isAuthenticated,
    autocompleteProductItem,
    goToUrl,
    extendedStyles,
    variant = "outlined",
    isFocused,
}) => {
    const { bunzlAutoCompleteBodyStyles, bunzlAutoCompleteFooterStyles, bunzlautoCompleteProductWrapperStyles } =
        extendedStyles ?? {};
    return (
        <BunzlAutoCompleteProductWrapper
            isFocused={isFocused}
            variant={variant}
            extendedStyles={bunzlautoCompleteProductWrapperStyles}
        >
            <BunzlAutoCompleteProductBody
                extendedStyles={bunzlAutoCompleteBodyStyles}
                isAuthenticated={isAuthenticated}
                autocompleteProductItem={autocompleteProductItem}
                goToUrl={goToUrl}
            />
            <BunzlAutoCompleteProductFooter
                extendedStyles={bunzlAutoCompleteFooterStyles}
                isAuthenticated={isAuthenticated}
                autocompleteProductItem={autocompleteProductItem}
                goToUrl={goToUrl}
            />
        </BunzlAutoCompleteProductWrapper>
    );
};

export default BunzlAutoCompleteProduct;
